import { ApiOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import WebhookActionNodeContent from 'automations/components/Nodes/WebhookActionNodeContent';
import { type WebhookNodeType } from 'automations/types/nodeSchemas/actionNodes';
import { nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type ActionNodeReturnProps } from './useActionNodeConfig';

export default function useWebhook(node: NodeProps<WebhookNodeType>): ActionNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.WebhookActionNodeData, node.data), [node.data]);
  const AdditionalUI = useMemo(() => <WebhookActionNodeContent node={node} />, [node]);

  return {
    icon: ApiOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    AdditionalUI,
  };
}
